import { Component, HostListener, Input, OnInit, OnDestroy, signal, AfterViewInit, Output, EventEmitter, inject } from '@angular/core';
import { NgClass, CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ScrollState } from '../../services/scroll-state';
import { Subscription } from 'rxjs';
import { Logo } from '../logo/logo';
import { ServiceCategoryService, ServiceCategory } from '../../services/service-category';
import { SiteSettingsService } from '../../services/site-settings.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  imports: [NgClass, CommonModule, RouterLink, Logo],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header implements OnInit, OnDestroy, AfterViewInit {
  @Input() lightMode = false;
  @Output() openBooking = new EventEmitter<void>();

  isScrolled = false;
  isMobileMenuOpen = false;
  scrollProgress = 0;
  private scrollSubscription?: Subscription;

  // Mega menu state
  isMegaMenuOpen = false;
  isMegaMenuReady = false; // Prevents flash on page load
  categories = signal<ServiceCategory[]>([]);
  activeCategory = signal<ServiceCategory | null>(null);
  storageUrl = environment.storageUrl;

  // Site settings — already loaded via APP_INITIALIZER
  private settings = inject(SiteSettingsService);
  hideLoginButton = signal(this.settings.val('others', 'others_hide_login') === '1');

  constructor(
    private scrollStateService: ScrollState,
    private categoryService: ServiceCategoryService
  ) {}

  ngOnInit() {
    this.scrollSubscription = this.scrollStateService.scrollProgress$.subscribe(
      progress => {
        this.scrollProgress = progress;
      }
    );

    this.loadCategories();
  }

  ngAfterViewInit() {
    // Delay enabling mega menu to prevent flash on page load
    setTimeout(() => {
      this.isMegaMenuReady = true;
    }, 100);
  }

  ngOnDestroy() {
    this.scrollSubscription?.unsubscribe();
  }

  loadCategories() {
    this.categoryService.getActive().subscribe({
      next: (res) => {
        if (res.status && res.data) {
          this.categories.set(res.data);
          // Set first category as active by default
          if (res.data.length > 0) {
            this.activeCategory.set(res.data[0]);
          }
        }
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 50;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  openMegaMenu() {
    this.isMegaMenuOpen = true;
  }

  closeMegaMenu() {
    this.isMegaMenuOpen = false;
  }

  setActiveCategory(category: ServiceCategory) {
    this.activeCategory.set(category);
  }

  getCategoryImage(category: ServiceCategory): string {
    if (category.image) {
      return `${this.storageUrl}/${category.image}`;
    }
    return '/images/placeholder-category.png';
  }

  get logoVariant(): 'light' | 'dark' {
    if (this.isScrolled) return 'dark';
    return this.lightMode ? 'light' : 'dark';
  }

  openBookingModal() {
    this.closeMegaMenu();
    this.isMobileMenuOpen = false;
    this.openBooking.emit();
  }
}
